module.exports = __webpack_public_path__ + "static/media/ic_snapshot_deactivate.671d4e54.svg";